export default {
	name: 'CopyRight',

	computed: {
		dateNow() {
			return new Date().getFullYear();
		}
	}
};